/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

// Images
import bgFront from "assets/images/gants.jpg";
import bgBack from "assets/images/pulverisateur.jpg";

function Information() {
  return (
    <MKBox component="section" py={6} my={6}>
      <Container>
        {/* <Grid container item xs={11} spacing={3} alignItems="center" sx={{ mx: "auto" }}>
          <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
            <RotatingCard>
              <RotatingCardFront
                image={bgFront}
                icon="touch_app"
                title={
                  <>
                    Feel the
                    <br />
                    Material Kit
                  </>
                }
                description="All the MUI components that you need in a development have been re-design with the new look."
              />
              <RotatingCardBack
                image={bgBack}
                title="Discover More"
                description="You will save a lot of time going from prototyping to full-functional code because all elements are implemented."
                action={{
                  type: "internal",
                  route: "/sections/page-sections/page-headers",
                  label: "start with header",
                }}
              />
            </RotatingCard>
          </Grid>
          <Grid item xs={12} lg={7} sx={{ ml: "auto" }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="content_copy"
                  title="Full Documentation"
                  description="Built by developers for developers. Check the foundation and you will find
                    everything inside our documentation."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="flip_to_front"
                  title="MUI Ready"
                  description="The world's most popular react components library for building user interfaces."
                />
              </Grid>
            </Grid>
            <Grid container spacing={3} sx={{ mt: { xs: 0, md: 6 } }}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="price_change"
                  title="Save Time & Money"
                  description="Creating your design from scratch with dedicated designers can be very expensive. Start with our Design System."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="devices"
                  title="Fully Responsive"
                  description="Regardless of the screen size, the website content will naturally fit the given resolution."
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid> */}

<Grid container item xs={11} spacing={3} alignItems="center" sx={{ mx: "auto" }}>
  <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
    <RotatingCard>
      <RotatingCardFront
        image={bgFront}
        icon="cleaning_services"
        title={
          <>
            Services de
            <br />
            Nettoyage
          </>
        }
        description="Nous offrons des services de nettoyage professionnels pour garantir un espace propre et sain."
      />
      <RotatingCardBack
        image={bgBack}
        title="À votre service"
        description="Bénéficiez d'une équipe qualifiée pour le nettoyage de vos bureaux et domiciles, avec des prestations sur mesure."
        action={{
          type: "internal",
          route: "/services",
          label: "Voir nos services",
        }}
      />
    </RotatingCard>
  </Grid>
  <Grid item xs={12} lg={7} sx={{ ml: "auto" }}>
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <DefaultInfoCard
          icon="handshake"
          title="Professionnalisme"
          description="Notre équipe qualifiée assure un service fiable, rapide et efficace, adapté à vos besoins."
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <DefaultInfoCard
          icon="eco"
          title="Produits Écologiques"
          description="Nous utilisons des produits respectueux de l’environnement pour un nettoyage efficace et sain."
        />
      </Grid>
    </Grid>
    <Grid container spacing={3} sx={{ mt: { xs: 0, md: 6 } }}>
      <Grid item xs={12} md={6}>
        <DefaultInfoCard
          icon="schedule"
          title="Flexibilité Horaires"
          description="Nous nous adaptons à votre emploi du temps pour un nettoyage sans interruption de vos activités."
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <DefaultInfoCard
          icon="verified"
          title="Qualité Garantie"
          description="Nos prestations sont contrôlées pour garantir une propreté impeccable et une satisfaction totale."
        />
      </Grid>
    </Grid>
  </Grid>
</Grid>

      </Container>
    </MKBox>
  );
}

export default Information;
